import { HttpLink } from '@apollo/client';
import fetch from 'cross-fetch';

export const httpLink = new HttpLink({
  uri: __GRAPH_API__,
  credentials: 'include',
  fetch
});
